function c(r, h, e) {
  return r.project(h), r.x = (r.x * 0.5 + 0.5) * e.width, r.y = e.height - (r.y * 0.5 + 0.5) * e.height, r.z = 0, r;
}
export {
  c as worldToScreen
};
//# sourceMappingURL=index38.js.map
